// Create and edit .env files accordingly when creating a new app.
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const STRIPE_PUBLISHABLE = process.env.REACT_APP_STRIPE_PUBLISHABLE;
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL;
export const APP_NAME = process.env.REACT_APP_NAME;
export const PRIVACY_POLICY_DATE = process.env.REACT_APP_PRIVACY_POLICY_DATE;
export const APP_YEAR = process.env.REACT_APP_APP_YEAR;
export const APP_URL = process.env.REACT_APP_APP_URL;
export const SPEECH_SERVER_URI = process.env.REACT_APP_SPEECH_SERVER_URI;
// Pages
export const WEBSITE_PAGE = "/";
export const PRIVACY_POLICY_PAGE = '/privacy-policy';
export const HOME_PAGE = "/home";
export const SETTINGS_PAGE = "/settings";
export const DOWNLOAD_PAGE = "https://mailchi.mp/30a4fd99efe6/subs-early-access";
// Alerts
export const ALERTS_TIMEOUT = 3000;
// Billing
export const CURRENCY_SYMBOLS = {"USD": "$", "EUR": "€"};
export const SUCCESSFUL_CHARGE = 'succeeded';
export const ACTIVE_SUBSCRIPTION = 'active';
export const CANCELED_SUBSCRIPTION = 'canceled';
export const CANCEL_PLAN_IMMEDIATELY = true;
// Notifications channels
export const EMAIL = "email_enabled";
export const SMS = "sms_enabled";
export const CHANNEL_TYPES = [EMAIL, SMS];
// THEMES
export const DARK_THEME = 'pt-dark';
export const LIGHT_THEME = 'pt-light';
export const FONT_INCREMENT = 2;
// Window sizes
export const DEFAULT_WIDTH = 1000;
export const DEFAULT_HEIGHT = 600;
export const SUBTITLES_WIDTH = 1200;
export const SUBTITLES_HEIGHT = 300;




// WEBPACK FOOTER //
// ./src/constants/index.js